import { useReducer } from 'react';

/**
 * 객체 조작을 위한 리듀서 훅
 * @param {Object} param 추가/수정할 객체
 * @return {Object} 추가/수정된 객체
 */
function useObjReducer(param) {
  return useReducer(
    (prev, curr) => ({
      ...prev,
      ...curr
    }),
    param
  );
}

export default useObjReducer;
